module.exports = __webpack_public_path__ + "static/media/20-2.ee3c4567.mp3";